import { SimpleSignal } from "./SimpleSignal";

export class Collection<T>
{
	public change: SimpleSignal;

	private _array:T[];
	private _object:{[key: string] : T} = {};
	private _keyProperty:string;
	private _simpleValues:boolean = false;

	constructor(array:T[], keyProperty:string = "id")
	{
		this._array = array;
		this._keyProperty = keyProperty;

		if (array[0] && array[0][keyProperty] === undefined)
		{
			this._simpleValues = true;
		}

		for (var i = 0, ln = array.length; i < ln; i++)
		{
			var array_i = array[i];
			var value = array_i[keyProperty];
			if (value !== undefined)
			{
				this._object[value] = array_i;
			}
		}

		this.change = new SimpleSignal();
	}

	public add(item:T)
	{
		var keyValue = item[this._keyProperty];
		this._object[keyValue] = item;
		this._array.push(item);

		this.change.dispatch();
	}

	public get array()
	{
		return this._array;
	}

	public get object()
	{
		return this._object;
	}

	public getByKey(key: string):any
	{
		return this._simpleValues ? key : this._object[key];
	}

	public get keyProperty()
	{
		return this._keyProperty;
	}
}